import React, { FC, PropsWithChildren } from 'react';
import { FormControl, FormControlProps } from './index';
import {
  Switch as ChakraSwitch,
  SwitchProps as ChakraSwitchProps,
  Flex,
  FormLabel,
  Spacer,
  VStack,
} from '@cardboard-ui/react';

interface SwitchProps extends ChakraSwitchProps {
  children?: React.ReactNode;
}

export const Switch = ({ children, defaultChecked, ...props }: SwitchProps) => {
  return (
    <Flex alignItems="center" width="100%">
      <FormLabel margin={0} marginRight={1}>
        {children}
      </FormLabel>
      <Spacer />
      <ChakraSwitch defaultChecked={defaultChecked} {...props}></ChakraSwitch>
    </Flex>
  );
};

export const SwitchGroup: FC<PropsWithChildren<FormControlProps>> = ({
  formid,
  label,
  isOptional,
  errorMessage,
  helpText,
  introText,
  children,
}) => {
  return (
    <FormControl
      formid={formid}
      errorMessage={errorMessage}
      helpText={helpText}
      isOptional={isOptional}
      introText={introText}
      label={label}
    >
      <VStack spacing={2} alignItems="start" id={formid}>
        {children}
      </VStack>
    </FormControl>
  );
};
